export default __webpack_public_path__ + "static/media/puertas-grill.60688f33.PNG";